<script setup lang="ts">
const emit = defineEmits<{
  'open-static-site': [pageId: string]
}>()

const openStaticSite = (pageId: string) => {
  emit('open-static-site', pageId)
}
</script>

<template>
  <footer class="bg-[#FEFEFE] py-6 px-5 sm:px-8">
    <div class="mx-auto flex max-w-5xl flex-col gap-4">
      <div class="flex flex-wrap justify-center gap-x-6 gap-y-2">
        <button
          class="cursor-pointer text-sm text-stone-700 transition-colors hover:text-stone-900"
          @click="openStaticSite('about')"
        >
          About
        </button>
        <button
          class="cursor-pointer text-sm text-stone-700 transition-colors hover:text-stone-900"
          @click="openStaticSite('keyboard-shortcuts')"
        >
          Keyboard Shortcuts
        </button>
      </div>

      <div class="flex flex-wrap items-center justify-center gap-4 text-xs text-stone-700">
        <span>© 2026 routecamp</span>
        <button
          class="cursor-pointer transition-colors hover:text-stone-700"
          @click="openStaticSite('terms-of-use')"
        >
          Terms of Use
        </button>
        <button
          class="cursor-pointer transition-colors hover:text-stone-700"
          @click="openStaticSite('eu-data-protection')"
        >
          Data Protection
        </button>
        <button
          class="cursor-pointer transition-colors hover:text-stone-700"
          @click="openStaticSite('privacy-policy')"
        >
          Privacy
        </button>
        <button
          class="cursor-pointer transition-colors hover:text-stone-700"
          @click="openStaticSite('imprint')"
        >
          Imprint
        </button>
      </div>
    </div>
  </footer>
</template>
